import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { ConfigService } from './config.service';
import { StaffingPlan } from '../models/staffing-plan.model';
import { AcuityCensusRecord } from '../models/acuity-census-record.model';
import { StaffRatioValue } from '../models/staff-ratio-value.model';

@Injectable({
    providedIn: 'root'
})
export class RecommendationService {
    private apiUrl = `${this.config.appSettings.webApiServer}api/Recommendation/`;

    constructor(
        private config: ConfigService,
        private http: HttpClient) {
    }

    makeAcuityRecommendation(shiftBlockId: number, workflowDate: string, acuityCensusRecords: AcuityCensusRecord[]): Promise<StaffingPlan[]> {
        const params = new HttpParams()
                            .set('acuityCensusRecords', JSON.stringify(acuityCensusRecords))
                            .set('shiftBlockId', shiftBlockId.toString())
                            .set('workflowDate', workflowDate);

        return this.http.get<StaffingPlan[]>(`${this.apiUrl}MakeAcuityRecommendation`, { params : params }).toPromise();
    }

    makeTotalUosRecommendation(shiftBlockId: number, workflowDate: string, totalUos: number): Promise<StaffingPlan[]> {
        const params = new HttpParams()
                            .set('totalUos', totalUos.toString())
                            .set('shiftBlockId', shiftBlockId.toString())
                            .set('workflowDate', workflowDate);

        return this.http.get<StaffingPlan[]>(`${this.apiUrl}MakeTotalUosRecommendation`, { params : params }).toPromise();
    }

}